import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { colors, calculateSpacing } from '@vds/theme';
import { IconData } from '@vds/icons';
import { DatePicker as CoreDatePicker } from '@vds-core/inputs';
import Calendar from './Calendar';
import { calculateRem } from '@uie/javascript-style-helpers';
import { BodyConfig, Body, TypographyConfig } from '@vds/typography';
import { Tooltip } from '@vds/tooltips';
var propTypes = {
  /**
   * If false, returns 'optional' next to input label. Defaults to true.
   */
  required: PropTypes.bool,

  /**
   * If provided, determines the width of the DatePicker field
   */
  width: PropTypes.string,

  /**
   * If provided, the Input will be rendered in the Disabled State.
   */
  disabled: PropTypes.bool,

  /**
   * String, array or node containing the title of the TooltipDialog
   */
  tooltipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * String, array or node containing the body content of the TooltipDialog
   */
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * If provided, will contain the string for the helper text
   */
  helperText: PropTypes.string,

  /**
   * Determines the placement of the helper text (right or bottom)
   */
  helperTextPlacement: PropTypes.oneOf(['right', 'bottom']),

  /**
   * If provided, the Calendar will always show on the Datepicker.
   */
  alwaysOpen: PropTypes.bool
};
var defaultProps = {
  required: true,
  disabled: false,
  helperTextPlacement: 'bottom',
  width: '100%',
  tooltipTitle: undefined,
  tooltipContent: undefined,
  helperText: undefined,
  alwaysOpen: false
};

var DatePicker = function DatePicker(props) {
  var required = props.required,
      disabled = props.disabled,
      minDate = props.minDate,
      pastDatesDisabled = props.pastDatesDisabled,
      helperText = props.helperText,
      helperTextPlacement = props.helperTextPlacement,
      tooltipTitle = props.tooltipTitle,
      tooltipContent = props.tooltipContent,
      alwaysOpen = props.alwaysOpen;

  function _calculateInputPadding(iconFocusState, error) {
    return calculateRem(12, 12, 12, 44);
  }

  return /*#__PURE__*/React.createElement(CoreDatePicker, _extends({}, props, {
    Calendar: Calendar,
    hoverState: true,
    iconFocusState: true,
    focusState: true,
    readOnlyBorders: true,
    overflowEllipsis: true,
    placeHolderText: null,
    iconConfig: IconData,
    iconPosition: "right",
    calculateInputPadding: _calculateInputPadding,
    labelMarginBottom: calculateSpacing('1X'),
    typescale: TypographyConfig.getTypescale(),
    color: colors,
    disabled: disabled,
    required: required,
    bodyConfig: BodyConfig,
    placeholder: null,
    minDate: minDate,
    renderErrorIcon: true,
    inputHeight: calculateRem(44),
    pastDatesDisabled: true,
    helperText: helperText,
    helperTextPlacement: helperTextPlacement,
    Tooltip: Tooltip,
    tooltipTitle: tooltipTitle,
    tooltipContent: tooltipContent,
    maxWidth: calculateRem(596),
    Body: Body,
    minWidth: calculateRem(168),
    alwaysOpen: alwaysOpen
  }));
};

DatePicker.propTypes = propTypes;
DatePicker.defaultProps = defaultProps;
export default DatePicker;